.header {
  white-space: nowrap;
}
